import api from '../../plugins/api';

// POST /api/crm/vin-blacklist/import — файл .xlsx/.xls/.csv: колонка «VIN» и, по желанию, «Причина».
const importVinBlacklist = (files) => {
  const formData = new FormData();
  files.forEach((file) => formData.append('files', file));

  return api.post('/api/crm/vin-blacklist/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export default importVinBlacklist;
